import 'aws-amplify/auth/enable-oauth-listener';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { NonAuthenticatedRoute } from '@/app/constant';
import { useAuth } from '@/state/auth';
import { useGlobalState } from '@/state/global.state';
import { useSearchParams } from '@/utils/url.util';

const AWSMarketplace: React.FC = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();

  const { searchParams } = useSearchParams();

  const { awsMarketplaceConfig } = useGlobalState();

  useEffect(() => {
    if (searchParams && searchParams.toString()) {
      awsMarketplaceConfig.onChange(Object.fromEntries(searchParams));

      if (isSignedIn) {
        awsMarketplaceConfig.onVerifyLinkingChange(true);
      }
    }
    navigate(isSignedIn ? '/' : NonAuthenticatedRoute.SIGNUP, {
      replace: true,
    });
  }, []);

  return null;
};

export default AWSMarketplace;
